import { Box } from "@mui/material";
import React from "react";
import Text from "./text/Text";
import CommonSkeleton from "./CommonSkeleton";
import Link from "@mui/material/Link";
import { details, transaction } from "./messages";
import { useLocation, useParams } from "react-router-dom";
import Breadcrumbs from "./breadCrumbs/BreadCrumbs";
import { generateBreadCrumbData, routeBreadcrumbs } from "./constants";
import classNames from "classnames";
import { useSelector } from "react-redux";
import CommonHeader from "./CommonHeader";

function TransactionDetailSkeleton() {
  const location = useLocation();
  const params = useParams();

  const { taprootAsset } = useSelector((state) => state.common);

  const { uuid: currency } = { ...taprootAsset };

  const currencyColor = classNames("bg-color-" + currency);

  const breadcrumbData = generateBreadCrumbData(
    location,
    routeBreadcrumbs,
    params
  );
  const displayDetail = (width) => {
    return (
      <Box mb="24px">
        <Text className="grey-text" size={16} font="regular">
          <CommonSkeleton width="68px" />
        </Text>
        <Text className="default-text " size={16} font="semibold">
          <CommonSkeleton width={width || "170px"} />
        </Text>
      </Box>
    );
  };
  return (
    <>
      <CommonHeader textAfterIcon={details} icon="backArrow" />
      <Box className="options-container">
        {/* <Box display="flex" justifyContent="center">
          <Breadcrumbs
            breadcrumbData={breadcrumbData}
            component={Link}
            sx={{ marginTop: "20px" }}
          />
        </Box> */}
        <Box className="all-transaction-wrapper">
          <Box className={`transaction-container all-transactions`}>
            <Box
              className={`amount-section ${currencyColor}`}
              sx={{ padding: "30px 30px" }}
              alignItems="center"
            >
              <CommonSkeleton variant="circle" height="50px" width="50px" />
              <Text
                className={`txt-uppercase mt-16 `}
                withIcon="end"
                size={16}
                font="semibold"
              >
                <CommonSkeleton width="70px" />
              </Text>
              <Text className="default-text amount" size={34} font="semibold">
                <CommonSkeleton />
              </Text>
              <Text className="grey-text" size={24} font="semibold">
                <CommonSkeleton width="98px" />
              </Text>
            </Box>
            <Box className="detail-section">
              <Box mt="30px">
                {displayDetail()}
                {displayDetail()}
                {displayDetail()}
              </Box>
              <Box className="detail" mt="30px">
                {displayDetail()}
              </Box>
            </Box>
            {displayDetail(520)}
            {displayDetail(520)}
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default TransactionDetailSkeleton;
